import { render, staticRenderFns } from "./RoutingSUList.vue?vue&type=template&id=0b9fce9b&"
import script from "./RoutingSUList.vue?vue&type=script&lang=js&"
export * from "./RoutingSUList.vue?vue&type=script&lang=js&"
import style0 from "./RoutingSUList.vue?vue&type=style&index=0&id=0b9fce9b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports